<template>
    <x-text-field
        :name="name"
        v-model="num"
        :rules="rules"
        :mask="mask"
        :hint="formattedNumber"
        :persistent-hint=true
        :hide-details="hideDetails"
        :maxlength="maxLength"
        :disabled="disabled"
        ref="currencyTextField"
        v-bind="$attrs"
        @keydown="numericKeydown($event)"
    />
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'XNumericalTextField',
        props: {
            value: {},
            name: {},
            rules: {},
            currency: {},
            inputStyle: {},
            items: {},
            hideDetails: {
                type: Boolean
            },
            hideHelper: Boolean,
            disabled: {},
            mask: {},
            maxLength: {
                default: 18,
                type: Number
            },
            noDecimal: Boolean
        },
        computed: {
            formattedNumber() {
                if (this.hideHelper) {
                    return undefined;
                }

                return this.$options.filters.numberToEnglish(this.num);
            },
            num: {
                get () {
                    if (this.noDecimal) {
                        return this.$options.filters.formatMoney(this.value);
                    }
                    return this.$options.filters.formatMoney(this.value, 2);
                },
                set (newValue) {
                    const cleanNumber = newValue === '' ? '' : parseFloat(newValue.toString().replace(/,/g, ''));
                    this.$emit('input', cleanNumber);
                }
            }
        },
        methods: {
            numericKeydown(e) {
                const allowedKeyPressed = (/^\d|\.|,|Delete|Backspace|Tab|^Arrow.*$/).test(e.key);
                const copyPasteOrSelectAllPressed = (e.ctrlKey || e.metaKey) && (/^([VvCcAa])$/).test(e.key);

                if ((allowedKeyPressed || copyPasteOrSelectAllPressed) === false) {
                    e.preventDefault();
                }
            }
        },
        watch: {
            num: function (newNum = '', oldNum = '') {
                newNum = newNum || '';
                oldNum = oldNum || '';

                // Keep the cursor in the correct position after formatting the number (1000 to 1,000 etc)
                const {input} = this.$refs.currencyTextField.$refs;
                const movement = (newNum.match(/,/g) || []).length - (oldNum.match(/,/g) || []).length;
                const newPos = input.selectionStart + movement;

                this.$nextTick(() => {
                    input.selectionStart = newPos;
                    input.selectionEnd = newPos;
                });
            }
        }
    }
</script>
